/* Drukke Mama's variantafbeeldingen-filter voor de PDP.

   Conventie uit de oude shop: de media staan in een vaste volgorde.
   - De media vóór de featured image van de eerste variant zijn gedeeld en
     horen bij élke variant (bv. sfeerbeelden).
   - Daarna volgt per variant een aaneengesloten blok, van de featured image
     van die variant tot (net vóór) de featured image van de volgende variant.
     Dat blok bevat zowel foto's als video's.
   Bij een variantkeuze tonen we het gedeelde begin + het blok van die variant;
   al de rest wordt verborgen met .dm-media-hidden — in de gallery, de
   thumbnails en de lightbox.

   Data komt uit #DmVariantMedia-<section>. Producten zonder varianten of
   zonder variantfoto's tonen alles. */
(function () {
  if (customElements.get('dm-variant-media')) return;

  class DmVariantMedia extends HTMLElement {
    connectedCallback() {
      const dataEl = document.getElementById(`DmVariantMedia-${this.dataset.section}`);
      if (!dataEl) return;
      try {
        this.config = JSON.parse(dataEl.textContent);
      } catch (error) {
        return;
      }

      this.featuredPositions = this.config.variants
        .map((variant) => variant.position)
        .filter((position) => position != null)
        .sort((a, b) => a - b);

      this.apply(this.config.selected);

      /* PUB_SUB_EVENTS staat als `const` in constants.js en hangt dus niet aan
         window; de bare identifier wél bereikbaar via de scope-keten. */
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const variant = event?.data?.variant;
          if (variant) this.apply(variant.id);
        });
      }

      /* Vangnet: product-info.js zet de verborgen variant-input al vóór het
         hertekenen van de gallery, dus hierop filteren we zelfs iets vroeger. */
      this.onVariantInput = (event) => {
        const input = event.target;
        if (input?.name !== 'id') return;
        if (!input.closest(`product-info[data-section="${this.dataset.section}"]`)) return;
        this.apply(input.value);
      };
      document.addEventListener('change', this.onVariantInput);
    }

    disconnectedCallback() {
      this.unsubscribe?.();
      document.removeEventListener('change', this.onVariantInput);
    }

    allowedMediaIds(variantId) {
      if (!this.featuredPositions.length) return null;
      const variant = this.config.variants.find((entry) => String(entry.id) === String(variantId));
      if (!variant || variant.position == null) return null;

      const start = variant.position;
      const next = this.featuredPositions.find((position) => position > start);
      const end = next ?? Infinity;
      const firstFeatured = this.featuredPositions[0];

      const allowed = new Set();
      this.config.media.forEach((media) => {
        const isShared = media.position < firstFeatured;
        const inBlock = media.position >= start && media.position < end;
        if (isShared || inBlock) allowed.add(String(media.id));
      });
      return allowed;
    }

    apply(variantId) {
      const allowed = this.allowedMediaIds(variantId);
      if (allowed === null) return;
      const sectionId = this.dataset.section;

      /* Per onderdeel exact de media-items selecteren — niet de geneste
         data-media-id's (deferred-media/product-model binnen een slide). */
      const groups = [
        [document.getElementById(`Slider-Gallery-${sectionId}`), ':scope > li[data-media-id]'],
        [document.getElementById(`Slider-Thumbnails-${sectionId}`), ':scope > li[data-target]'],
        [
          document.getElementById(`ProductModal-${sectionId}`),
          '.dm-lightbox__slide[data-media-id], .dm-lightbox__thumb[data-media-id]',
        ],
      ];

      groups.forEach(([scope, selector]) => {
        if (!scope) return;
        scope.querySelectorAll(selector).forEach((item) => {
          const raw = item.dataset.mediaId || item.dataset.target || '';
          const mediaId = raw.split('-').pop();
          item.classList.toggle('dm-media-hidden', !allowed.has(mediaId));
        });
      });

      this.updateSliders(sectionId);
    }

    updateSliders(sectionId) {
      /* Teller van de mobiele slider bijwerken en de slider-paginatie resetten. */
      const gallery = document.getElementById(`GalleryViewer-${sectionId}`);
      if (gallery) {
        const visible = gallery.querySelectorAll('.product__media-item:not(.dm-media-hidden)').length;
        const total = gallery.querySelector('.slider-counter--total');
        if (total) total.textContent = visible;
        if (typeof gallery.resetPages === 'function') gallery.resetPages();
      }
      const thumbnails = document.getElementById(`GalleryThumbnails-${sectionId}`);
      if (thumbnails && typeof thumbnails.resetPages === 'function') thumbnails.resetPages();
    }
  }

  customElements.define('dm-variant-media', DmVariantMedia);
})();
